import React from "react";
import { Link } from "react-router-dom";
import { MdOutlineSpaceDashboard, MdPhoneCallback } from "react-icons/md";
import { TbUsers } from "react-icons/tb";
import {
  RiShieldUserLine,
  RiLockPasswordLine,
  RiCustomerService2Line,
  RiStockFill,
  RiCoupon3Fill,
} from "react-icons/ri";
import { BiHeading, BiBookContent } from "react-icons/bi";
import { FaFileInvoiceDollar } from "react-icons/fa";
import { MdEmail } from "react-icons/md";

import styles from "./MainNav.module.css";

import NavItem from "./NavItem/NavItem";

import Logo from "../../../assets/images/logo.svg";

const MainNav = () => {
  return (
    <div className={styles.MainNav}>
      <div className={styles.Logo}>
        <Link to="/">
          <img src={Logo} alt="Lara Capital" />
        </Link>
      </div>
      <ul className={styles.NavBar}>
        <div>
          <NavItem link="/" exact>
            <MdOutlineSpaceDashboard /> Dashboard
          </NavItem>

          <NavItem link="/users">
            <TbUsers /> Users
          </NavItem>

          <NavItem link="/brokers">
            <RiStockFill /> Brokers
          </NavItem>

          <NavItem link="/brokers-headings">
            <BiHeading /> Brokers Headings
          </NavItem>

          <NavItem link="/invoices">
            <FaFileInvoiceDollar /> Invoices
          </NavItem>

          <NavItem link="/statement-requests">
            <BiBookContent /> Statement Requests
          </NavItem>

          <NavItem link="/offers">
            <RiCoupon3Fill /> Offers
          </NavItem>

          <NavItem link="/offers-interests">
            <MdEmail /> Offers Interests
          </NavItem>

          <NavItem link="/tickets">
            <RiCustomerService2Line /> Tickets
          </NavItem>

          <NavItem link="/call-requests">
            <MdPhoneCallback /> Call Requests
          </NavItem>

          <NavItem link="/admins">
            <RiShieldUserLine /> Admins
          </NavItem>

          <NavItem link="/change-password">
            <RiLockPasswordLine /> Change Password
          </NavItem>
        </div>
      </ul>
    </div>
  );
};

export default MainNav;
